import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-92aed8e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  role: "main",
  "aria-label": "비밀번호 찾기"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref: "contentsBody",
        class: "find-login-info-container",
        onTouchstart: $setup.onTouchStart,
        onTouchend: $setup.onTouchEnd
      }, [
        _createVNode($setup["NavigationBar"], { title: "비밀번호 찾기" }),
        _createElementVNode("main", _hoisted_1, [
          _createVNode($setup["FindLoginPassword"], { class: "find-password-container" })
        ])
      ], 544 /* NEED_HYDRATION, NEED_PATCH */)
    ]),
    _: 1 /* STABLE */
  }))
}